import { withAccountUtm } from "@/utils/account-utm";

export const COSMETIC_COLLEGE_APP_NAME = "Cosmetic College" as const;

export const COSMETIC_COLLEGE_APP_PAGE_PATH = "/cosmetic-college-app/" as const;

export const COSMETIC_COLLEGE_APP_BUNDLE_ID =
  "com.cosmeticcollege.forms" as const;

export const COSMETIC_COLLEGE_APP_DESCRIPTION =
  "Cosmetic College is the companion app for students completing beauty and aesthetics training. Keep your training journey moving from one place. Complete onboarding, manage programmes, revise for exams, complete assignments, upload evidence and stay on top of your next steps." as const;

export const COSMETIC_COLLEGE_ANDROID_PACKAGE = COSMETIC_COLLEGE_APP_BUNDLE_ID;

export const COSMETIC_COLLEGE_ANDROID_PLAY_STORE_URL =
  `https://play.google.com/store/apps/details?id=${COSMETIC_COLLEGE_ANDROID_PACKAGE}` as const;

export const COSMETIC_COLLEGE_IOS_APP_STORE_ID = "6788717535" as const;

export const COSMETIC_COLLEGE_IOS_APP_STORE_URL =
  `https://apps.apple.com/gb/app/cosmetic-college/id${COSMETIC_COLLEGE_IOS_APP_STORE_ID}` as const;

export const COSMETIC_COLLEGE_IOS_BUNDLE_ID = COSMETIC_COLLEGE_APP_BUNDLE_ID;

const STUDENT_APP_UTM = {
  utm_medium: "referral",
  utm_campaign: "student-account",
} as const;

const LANDING_APP_UTM = {
  utm_medium: "referral",
  utm_campaign: "cosmetic-college-app",
} as const;

export const COSMETIC_COLLEGE_IOS_APP_STORE_ACCOUNT_URL = withAccountUtm(
  COSMETIC_COLLEGE_IOS_APP_STORE_URL,
  {
    ...STUDENT_APP_UTM,
    utm_content: "app-store",
  },
);

export const COSMETIC_COLLEGE_ANDROID_PLAY_STORE_ACCOUNT_URL = withAccountUtm(
  COSMETIC_COLLEGE_ANDROID_PLAY_STORE_URL,
  {
    ...STUDENT_APP_UTM,
    utm_content: "google-play",
  },
);

export const COSMETIC_COLLEGE_IOS_APP_STORE_LANDING_URL = withAccountUtm(
  COSMETIC_COLLEGE_IOS_APP_STORE_URL,
  {
    ...LANDING_APP_UTM,
    utm_content: "app-store",
  },
);

export const COSMETIC_COLLEGE_ANDROID_PLAY_STORE_LANDING_URL = withAccountUtm(
  COSMETIC_COLLEGE_ANDROID_PLAY_STORE_URL,
  {
    ...LANDING_APP_UTM,
    utm_content: "google-play",
  },
);

export const COSMETIC_COLLEGE_APP_ICON_URL =
  "/images/cosmetic-college-app-icon.png" as const;

export const COSMETIC_COLLEGE_APPLE_BADGE_URL =
  "/images/apple-download.png" as const;

export const COSMETIC_COLLEGE_GOOGLE_BADGE_URL =
  "/images/google-download.png" as const;

const sharedAppPublisher = {
  "@type": "Organization" as const,
  name: "Cosmetic College",
  url: "https://www.cosmetic.college/",
  logo: "https://www.cosmetic.college/logo/cc-logo@3x.png",
};

function buildMobileApplicationSchema({
  storeUrl,
  operatingSystem,
  idSuffix,
}: {
  storeUrl: string;
  operatingSystem: "ANDROID" | "iOS";
  idSuffix: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "MobileApplication",
    "@id": `${storeUrl}#${idSuffix}`,
    name: COSMETIC_COLLEGE_APP_NAME,
    alternateName: "Cosmetic College Student App",
    description: COSMETIC_COLLEGE_APP_DESCRIPTION,
    url: storeUrl,
    installUrl: storeUrl,
    downloadUrl: storeUrl,
    applicationCategory: "EducationalApplication",
    operatingSystem,
    countriesSupported: "GB",
    inLanguage: "en-GB",
    isAccessibleForFree: true,
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "GBP",
      availability: "https://schema.org/InStock",
      url: storeUrl,
    },
    author: {
      "@type": "Organization",
      name: "Cosmetic College",
      url: "https://www.cosmetic.college/",
    },
    publisher: sharedAppPublisher,
    screenshot: "https://www.cosmetic.college/logo/cc-logo@3x.png",
  };
}

export function buildCosmeticCollegeAndroidAppSchema() {
  return buildMobileApplicationSchema({
    storeUrl: COSMETIC_COLLEGE_ANDROID_PLAY_STORE_URL,
    operatingSystem: "ANDROID",
    idSuffix: "android-mobile-application",
  });
}

export function buildCosmeticCollegeIosAppSchema() {
  return buildMobileApplicationSchema({
    storeUrl: COSMETIC_COLLEGE_IOS_APP_STORE_URL,
    operatingSystem: "iOS",
    idSuffix: "ios-mobile-application",
  });
}
